import React from 'react';
export var ZipcodeContext = React.createContext({});
export default (function (_ref) {
  var initialZipInfo = _ref.initialZipInfo,
    children = _ref.children;
  return React.createElement(ZipcodeContext.Provider, {
    value: initialZipInfo
  }, children);
});